<template>
  <div class="container full-height">
    <h1>{{$t('Register.Mieter.Headline')}}</h1>

    <form @submit.prevent="register" class="full-height"> 
        <!-- Stepers Wrapper -->
          <div class="step-wrapper full-height">
            <div class="step step-1" v-if="step == 1">
              <h2>{{$t('Register.Mieter.Infos')}}</h2>
                <!-- Material input -->
                <mdb-input type="email" :label="$t('Register.Mieter.Email')" v-model="user.email" v-on:blur="validateEmail"/>
                <mdb-input type="password" :label="$t('Register.Mieter.Passwort')" v-model="user.password" />
                <mdb-input type="password" :label="$t('Register.Mieter.Passwortconfirm')" v-model="user.password_confirmation" />
                
            </div>

            <div class="step step-2" v-if="step == 2">
              <h2>{{$t('Register.Mieter.Infos')}}</h2>
                <!-- Material input -->
                <mdb-select v-model="status" @change="changeStatus($event)" :label="$t('Register.Mieter.Status')" :placeholder="$t('Register.Mieter.Statuswahlen')" ></mdb-select>
                <mdb-select v-model="institution" @change="changeInstitution($event)" :label="$t('Register.Mieter.Institution')" :placeholder="$t('Register.Mieter.Institutionwahlen')" ></mdb-select>


                
                <mdb-input :label="$t('Register.Mieter.Institutiongruppe')" v-model="user.institutionuntergruppe" />
                <mdb-input :label="$t('Register.Mieter.Vorname')" v-model="user.vorname" />
                <mdb-input :label="$t('Register.Mieter.Nachname')" v-model="user.nachname" />
                
                <div class="form-horizontal">
                <div class="form-group">
                  <mdb-select v-model="country" @change="changeCountry($event)" :label="$t('Register.Mieter.Nationalitaet')" :placeholder="$t('Global.Auswahlen')" ></mdb-select>
                  <!--<div class="row mb-5">
                  <div class="col-3 text-left">
                      <label>{{$t('Register.Mieter.Geschlecht')}}</label>
                  </div>
                  <div class="col-9">
                    <div class="d-flex align-items-start flex-column">
                      <mdb-input type="radio" id="geschlecht-1" name="geschlecht" radioValue="w" v-model="user.geschlecht" :label="$t('Register.Mieter.Weiblich')" />
                      <mdb-input type="radio" id="geschlecht-2" name="geschlecht" radioValue="m" v-model="user.geschlecht" :label="$t('Register.Mieter.Maennlich')" />
                     
                      
                        </div>
                      </div>
                </div>-->
                </div>
              </div>
            </div>


            <div class="step step-3" v-if="step == 3">
              <h2>{{$t('Register.Mieter.Infos')}}</h2>
                <!-- Material input -->
                <div class="row mb-5">
                  <div class="col-3 text-left">
                      <label>{{$t('Register.Mieter.Aufenthaltvon')}}</label>
                  </div>
                  <div class="col-9">
                    <mdb-date-picker v-model="user.aufenthaltVon" :option="option" />
                  </div>
                </div>
                <div class="row mb-5">
                  <div class="col-3 text-left">
                      <label>{{$t('Register.Mieter.Aufenthaltbis')}}</label>
                  </div>
                  <div class="col-9">
                    <mdb-date-picker v-model="user.aufenthaltBis" :option="option"/>
                  </div>
                </div>
                <div class="row mb-5">
                  <div class="col-3 text-left">
                      <label>{{$t('Register.Mieter.Mitfamilie')}}</label>
                  </div>
                  <div class="col-9">
                    <div class="d-flex align-items-start flex-column">
                      <!-- Material input -->
                      <!-- Group of material radios - option 2 -->
                       <mdb-input type="radio" id="familie-1" name="familie" radioValue="Ja" v-model="user.mitfamilie" :label="$t('Global.Ja')" />
                       <mdb-input type="radio" id="familie-2" name="familie" radioValue="Nein" v-model="user.mitfamilie" :label="$t('Global.Nein')" />
                      
                        </div>
                      </div>
                </div>
                              
                <div class="md-form">
                  <mdb-input :label="$t('Register.Mieter.Sonstige')" v-model="user.sonstiges" />
                  
                </div>
            </div>

            <div class="step step-4" v-if="step == 4">
              <h2 class="mb-5">{{$t('Register.Mieter.Datenschutz')}}</h2>
              <div class="row mb-5">
                  <!-- Group of material radios - option 1 -->
                <div class="form-check mb-3">
                  <div class="clickable" v-on:click="openTerms">
                    {{$t('Register.Mieter.Nutzerbedingungen')}}
                  </div>
                </div>

                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="terms" name="terms" value="terms" required v-model="terms.term1">
                        <label class="form-check-label" for="terms">{{$t('Register.Mieter.Datenschutz1')}}</label>
                      </div>
                      <!-- Group of material radios - option 1 -->
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="terms2" name="terms2" value="terms2" required v-model="terms.term2">
                        <label class="form-check-label" for="terms2">{{$t('Register.Mieter.Datenschutz2')}}</label>
                      </div>
                      <!-- Group of material radios - option 1 -->
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="terms3" name="terms3" value="terms3" v-model="terms.term3">
                        <label class="form-check-label" for="terms3">{{$t('Register.Mieter.Datenschutz3')}}</label>
                      </div>
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="terms4" name="terms4" value="terms4" v-model="terms.term4">
                        <label class="form-check-label" for="terms4">{{$t('Register.Mieter.Datenschutz4')}}</label>
                      </div>
                </div>
            </div>
          </div>
        <!-- /.Stepers Wrapper -->
        <div class="d-flex mb-5 justify-content-between align-items-center">

          <mdb-btn color="primary" class="mr-5" v-bind:class="{ active: step > 1 }"  @click.native.prevent="prev()">{{$t('Global.Vorherigeseite')}}</mdb-btn>
            <div class="mr-5 gutter"></div>
            <div class="flex-1">
                <mdb-progress :value="(this.step/4 * 100)" />
            </div>
            <div class="mr-5 gutter"></div>
          
          <mdb-btn color="primary"  v-if="step !== 4" v-bind:class="{ active: step <= 4 }"  @click.native.prevent="next()">{{$t('Global.Naechsteseite')}}</mdb-btn>
         
          <mdb-btn color="primary"  v-else class="" @click.native.prevent="register()">{{$t('Global.Benutzererstellen')}}</mdb-btn>
      
        </div>
        
        
      </form>
  </div>
</template>

<script>
// @ is an alias to /src
import settings from '@/components/Settings.json';
 import { mdbBtn, mdbInput, mdbDatePicker, mdbSelect, mdbProgress } from 'mdbvue';
import UserService from "@/services/UserService";
import EmailService from "@/services/EmailService";
export default {
  components:{
    mdbBtn,
            mdbInput,
            mdbDatePicker,
            mdbSelect,
      mdbProgress
  },
  props:['type'],
  data() {
    return {
      user:{
          aufenthaltBis: null,
          aufenthaltVon: null,
          email: "",
          mitfamilie: "",
          geschlecht:"",
          vorname:"",
          nachname:"",
          password:"",
          password_confirmation:"",
          status: "",
          institution: "",
          institutionuntergruppe: "",
          nationalitaet: "",
          sonstiges: "",
          type:1,
          expirationdate: null

      },
      terms:{
        term1: false,
        term2: false,
        term3: false,
        term4: false,
      },
      emailValid: true,
      activationNeeded: false,
      errorM: {},
      errorMessages: {
        messageOne: "Passwort stimmt nicht überein.",
        messageTwo: "Keine Email/Passwort eingegeben.",
        
      },
      step: 1,
      status:[
      ],
      institution:[
      ],
      country: [],
      option: {
        format: 'DD.MM.YYYY',
        week: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
        month: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'July', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        buttons: {
          ok: 'Ok',
          cancel: 'Abbrechen',
          today: 'Heute',
          clear: 'Löschen'
        }
      }
      
    };
  },
  mounted() {
    this.status = settings.Settings[1][this.$store.getters.lang][0].Bevorzugte;
    this.institution = settings.Settings[1][this.$store.getters.lang][0].Institution;
    this.country = settings.Settings[1][this.$store.getters.lang][0].country;
  },
  methods: {
    changeCountry(event){
      this.user.nationalitaet = event;
    },
      changeStatus(event) {
          this.user.status = event;
      },
      changeInstitution(event) {
          this.user.institution = event;
      },
    validateEmail(){
      UserService.validateEmail(this.user.email).then(response =>{

         this.emailValid = response.data;

      })
    },
    openTerms(){
      let routeData = this.$router.resolve({name: 'nutzerbedingungenMieter'});
      window.open(routeData.href, '_blank');
    },
    hashCode(str) {
      let hash = 0, i, chr, len;
      if (str.length === 0) return hash;
      for (i = 0, len = str.length; i < len; i++) {
        chr   = str.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
      }
      return hash;
    },
    register: function() {
      if(!this.terms.term1 || !this.terms.term2 || !this.terms.term3 || !this.terms.term4){
        this.$notify.warn({
          message: this.$t("Register.ConfirmTOS"),
          position: 'top right',
          timeOut: 4000
        });
        return
      }
      if(this.user.nationalitaet == "DE"){

        this.user.expirationdate = "1980-01-01";
        this.user.activationhash = this.hashCode(this.user.email);

      } else {
        this.user.expirationdate = null;
        this.user.activationhash = null;
      }
      /*this.user.expirationdate = "1980-01-01";
      this.user.activationhash = this.hashCode(this.user.email);

      */
      let oldUser = this.user;
      if(this.user.aufenthaltBis){
        this.user.aufenthaltBis = this.$func.formateDateForDB(this.user.aufenthaltBis);
      }
      if(this.user.aufenthaltVon){
        this.user.aufenthaltVon = this.$func.formateDateForDB(this.user.aufenthaltVon);
      }

      if(oldUser.mitfamilie == 1){
        oldUser.mitfamilie = "Ja";
      } else {
        oldUser.mitfamilie = "Nein";
      }


      let _this = this;
      this.$store.dispatch("register", this.user).then(response => {
              if(_this.user.expirationdate == "1980-01-01"){

                this.$notify.info({
                  message:  this.$t("Register.Vermieter.ConfirmNeeded"),
                  position: 'top right',
                  timeOut: 8000
                });
                UserService.login(_this.user.email, _this.user.password).then(response =>{
                  let u = JSON.stringify(oldUser);
                  EmailService.sendMail("RegistrierungMieterNichtUni","Registrierung", this.user.email, null, true);
                  EmailService.sendMail("RegistrierungMieterDeaktiviert","Wohnungssuchender muss aktiviert werden", 'wohnungsdatenbank.io@zv.uni-freiburg.de', u, true)
                })
                this.$router.push({ name: 'home'})

              } else {
                this.$notify.success({
                  message: this.$t("Register.Vermieter.Success"),
                  position: 'top right',
                  timeOut: 4000
                });
                EmailService.sendMail("RegistrierungMieter","Registrierung", _this.user.email, null,true);

                this.$store.dispatch("login", {username: _this.user.email, password: _this.user.password})
                this.$router.push({ name: 'home'})
              }

              })
              .catch(e => {
                this.$notify.warn({
                  message: this.$t("Register.Vermieter.Error"),
                  position: 'top right',
                  timeOut: 4000
                });
                console.log(e);
              });
      
    },
    next(){
      console.log(this.step)
        if (this.step == 4){ return}
        if(this.step == 1){

          if(this.user.password && this.user.password != "" && this.user.email && this.user.email != ""){
            if(!this.emailValid){
              this.$notify.error({
                message: this.$t("Register.Vermieter.ErrorEmailUsed"),
                position: 'top right',
                timeOut: 4000
              });
              return
            }
            if(this.user.email.indexOf("@uni-freiburg.de") != -1){
              this.$notify.error({
                message:  this.$t("Register.Vermieter.ErrorEmailWrong"),
                position: 'top right',
                timeOut: 4000
              });

            } else {
              if(this.user.password == this.user.password_confirmation){
                this.step++;
              }
            }

          } else {
              this.$notify.error({
                  message:   this.$t("Register.Vermieter.ErrorMissing"),
                  position: 'top right',
                  timeOut: 4000
              });
          }
        }
        else if(this.step == 2){
          if(!this.user.nationalitaet){
            this.$notify.error({
              message: this.$t("Register.Vermieter.ErrorMissing"),
              position: 'top right',
              timeOut: 4000
            });
            return
          } else {
            this.step++;
          }
        } else{
          this.step++;
        }
          
        

    },
    prev(){
        if (this.step == 1){ return}
          this.step--;
    
    }

  },
  computed: {

  }
};
</script>
<style scroped lang="scss">
.clickable{
  cursor: pointer;
  &:hover{
    color:#c1002a;
  }
}
</style>
